import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../atomic/text/Text';
import { timeFrameMap } from './timeFrameMap';

export const TimeFrameBox = ({ timeFrame }) => {
  const duration = timeFrame.candleDuration;
  const timeUnitAbbreviated = timeFrameMap[timeFrame.timeUnit];
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <div
        style={{
          width: '35px',
          border: '1px solid white',
          backgroundColor: colors.black,
          height: 'fit-content',
          textAlign: 'center',
          marginBottom: '3px',
        }}
      >
        <Body3 color={colors.lightGrey} fontWeight={700}>
          {`${duration}${timeUnitAbbreviated}`}
        </Body3>
      </div>
    </div>
  );
};

TimeFrameBox.propTypes = {
  timeFrame: PropTypes.shape({
    candleDuration: PropTypes.any,
    timeUnit: PropTypes.any
  })
};

